
/* eslint-disable max-classes-per-file */
import _ from "lodash";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { VKDirektutbyteTradslagDTO } from "./direktutbyte-models";
import { VKSnabbkalkylTradslagDTO } from "./snabbkalkyl-models";

export class VKForkalkylTradslagDTO {
    id: number;
    namn: string;
    sekvensnummer: number;
    externkod: string;
}

export class VKProduktGruppDTO {
    id?: number;
    namn: string;
    kod: string;
    sekvensnummer: number;
    handelssortimentsgruppId?: number;
    handelssortimentsgruppKod: string;
    handelssortimentsgruppNamn: string;
    handelssortimentsgruppSekvensNummer?: number;
    handelssortimentsgruppKategori: string;
    handelssortimentsgruppKortnamn: string;
}

export type TradslagItem = {
    tradslag: VKForkalkylTradslagDTO;
};

export type TradslagKalkylMetod = "snabbkalkyl" | "direktutbyte";

export type CellNameSnabbkalkyl = keyof Omit<VKSnabbkalkylTradslagDTO, "guid">;

export type CellNameDirektutbyte = keyof Omit<VKDirektutbyteTradslagDTO, "guid">;

export type VKForkalkylTradslagHDCellStyles =  Partial<Record<CellNameSnabbkalkyl, Cellstyle>>;

export type VKDirektutbyteTradslagHDCellStyles = Partial<Record<CellNameDirektutbyte, Cellstyle>>;

export const isNotGranOrTall = (item: TradslagItem) => ![
    1,
    2
].includes(item.tradslag.id);

export const isNotGran = (item: TradslagItem) => ![2].includes(item.tradslag.id);

export const meanRounded = (values: number[]) => _.chain(values)
    .mean()
    .round(1)
    .value();
